import type { BulkFieldListValue, BulkFieldSimpleValue } from '@/services/bulk/types'
import type { CustomFieldValueType } from '@/services/domain/cusomFields/types'

export const contactImportStepVariant = ['upload', 'matching', 'settings', 'cleanup', 'progress'] as const
export const contactImportInitialSteps = ['upload', 'matching', 'settings', 'progress'] as const
export type ContactImportStep = (typeof contactImportStepVariant)[number]

export const listIdsFieldName = 'listIds'

export const bulkCustomFieldPrefix = 'customField_'

export type ContactBulkFormData = {
  owner?: string
  tags?: BulkFieldListValue
  companyName?: BulkFieldSimpleValue<string>
} & {
  [key: `${typeof bulkCustomFieldPrefix}${string}`]: BulkFieldSimpleValue<CustomFieldValueType>
}
